/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_212480f4"]'><cube-button icon="audio" primary outline :loading="(loading)" @_click="clickBtn">加载按钮</cube-button></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_212480f4"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_212480f4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_212480f4"}
  /** script content **/
  require("./btn-outline-loading.mpx.js?isComponent&outputPath=components%2Fbtn-outline-loading212480f4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-outline-loading.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-outline-loading212480f4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_212480f4"],
    ctorType: "component",
    outputPath: "components/btn-outline-loading212480f4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>